// eslint-disable-next-line import/prefer-default-export
export const SET_LAYOUT_STORAGE = 'SET_LAYOUT_STORAGE';
